module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__thank-you--section"
  }, [(_vm.alreadySent === false) ? _c('div', {
    staticClass: "system-builder__thank-you--container"
  }, [_c('h1', [_vm._v("Thank you for reaching out to the customer.")]), _vm._v(" "), _c('p', [_vm._v("Hope you enjoy your install.")])]) : _c('div', {
    staticClass: "system-builder__thank-you--container"
  }, [_c('h1', [_vm._v("This request is closed")]), _vm._v(" "), _c('p', [_vm._v("Thank you for reaching out to the customer.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-310f48d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/DealerFollowupComplete.vue
// module id = 421
// module chunks = 1